<div class="modal-header">
  <h4 class="modal-title">
    {{'projectRequestPopup.label.use_price_caculation' | translate}}
  </h4>
  <button type="button" class="close pull-right" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <h2>{{getHeader()}}</h2>
    <p class="font-weight-bold">{{'projectRequestPopup.label.prompt_to_enter_request_data' | translate}}</p>
    <form class="form-horizontal"
    [formGroup]="form"
    novalidate>
      <div class="row">
        <div class="mb-3 col-sm-4">
          <label for="ang-1">{{'projectRequestPopup.label.total_demand' | translate}} *</label>
          <input class="form-control" id="ang-1" type="text" inputRestricter="^([1-9][0-9]{0,7})?$" formControlName="totalDemand" [class.is-invalid]="checkControlValidity('totalDemand')">
          <div class="invalid-feedback">{{form.controls.totalDemand.errors?.messageKey | translate}}</div>
        </div>
        <div class="mb-3 col-sm-4">
          <label for="ang-2">{{'projectRequestPopup.label.batch_size' | translate}} *</label>
          <input class="form-control" id="ang-2" type="text" inputRestricter="^([1-9][0-9]{0,7})?$" formControlName="batchSize" [class.is-invalid]="checkControlValidity('batchSize')">
          <div class="invalid-feedback">{{form.controls.batchSize.errors?.messageKey | translate}}</div>
        </div>
        <div class="mb-3 col-sm-4">
          <label for="ang-3">{{'projectRequestPopup.label.desired_delivery_date' | translate}} *</label>
          <div class="input-group">
            <input type="text" class="form-control" #dp="bsDatepicker" bsDatepicker [bsValue]="bsValue" [minDate]="startDate" [maxDate]="endDate" formControlName="deliveryDate" [class.is-invalid]="checkControlValidity('deliveryDate')">
            <span class="input-group-append">
              <button class="btn btn-secondary" type="button" (click)="dp.toggle()"><i class="fa fa-calendar"></i></button>
            </span>
            <div class="invalid-feedback">{{form.controls.deliveryDate.errors?.messageKey | translate}}</div>
          </div>
        </div>
      </div>
      <hr>
      <div class="row">
        <div class="mb-3 col-md-12">
          <label for="ang-4">{{'projectRequestPopup.label.remarks' | translate}}</label>
          <textarea name="" id="ang-4" class="form-control" rows="3" maxlength="1000" formControlName="remarks" [class.is-invalid]="checkControlValidity('remarks')"></textarea>
          <div class="invalid-feedback">{{form.controls.remarks.errors?.messageKey | translate}}</div>
        </div>
      </div>
      <div class="row">
        <div class="mb-3 col-sm-6">
          <label for="sapProjectNumber">{{'projectRequestPopup.label.sap_project_nr' | translate}}</label>
          <input class="form-control" id="sapProjectNumber" type="text" inputRestricter="^([0-9]{0,10})?$" formControlName="sapProjectNumber" [class.is-invalid]="checkControlValidity('sapProjectNumber')">
          <div class="invalid-feedback">{{form.controls.sapProjectNumber.errors?.messageKey | translate}}</div>
        </div>
      </div>
      <div *ngIf="useCustomAddressNumber">
        <p>
          {{'projectRequestPopup.label.add_customer_data' | translate}}
        </p>
        <div class="row">
          <div class="mb-3 col-sm-6">
            <label for="addressNumber">{{'projectRequestPopup.label.address_number' | translate}} *</label>
            <input class="form-control" id="addressNumber" type="text" inputRestricter="^([0-9]{0,10})?$" formControlName="addressNumber" [class.is-invalid]="checkControlValidity('addressNumber')">
            <div class="invalid-feedback">{{form.controls?.addressNumber.errors?.messageKey | translate:{'0':form.controls?.addressNumber.errors?.param} }}</div>
          </div>
          <div class="mb-3 col-sm-6">
            <label for="salesOrg">{{'projectRequestPopup.label.sales_org' | translate}} *</label>
            <input class="form-control" id="salesOrg" type="text" inputRestricter="^([0-9]{0,4})?$" formControlName="salesOrganisation" [class.is-invalid]="checkControlValidity('salesOrganisation')">
            <div class="invalid-feedback">{{form.controls?.salesOrganisation.errors?.messageKey | translate:{'0':form.controls?.salesOrganisation.errors?.param} }}</div>
          </div>
        </div>
      </div>
      <p class="middle">
        {{'projectRequestPopup.price_calculation.label.explanationText' | translate}}
      </p>
      <div class="row">
        <div class="mb-3 col-md-12">
          <label>* = {{'global.label.legend_required_field' | translate}}</label>
        </div>
      </div>
      <div class="font-weight-bold" *ngIf="highestFinalizedProjectVersion > -1">
        <span>{{ 'projectRequestPopup.label.html.calculation_price_hint_header' | translate }}</span>
        <p>{{ 'projectRequestPopup.label.html.calculation_price_hint' | translate : { '0': highestFinalizedProjectVersionDisplayStringWithDate } }}</p>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.cancel' | translate}}</button>
  <button type="submit" class="btn btn-primary" (click)="requestPrice()">
    <app-svg-icon type="calculator"/>
    <span>{{'projectRequestPopup.price_calculation.button.text' | translate}}</span>
  </button>
</div>
